import { clampListIndex } from './clamp-list-index';
import { shiftListIndex } from './shift-list-index';
import LightboxActionType, { LightboxAction } from './lightbox-reducer.actions';

import { LightboxState } from './lightbox-reducer.state';

export function lightboxReducer(state: LightboxState, action?: LightboxAction): LightboxState {
    switch (action?.type) {
        case LightboxActionType.SetIndex:
            return { ...state, index: clampListIndex(state.elements.length, action.payload) };
        case LightboxActionType.ShiftIndex:
            return {
                ...state,
                index: state.isLoopbackEnabled
                    ? shiftListIndex(state.elements.length, state.index, action.payload)
                    : clampListIndex(state.elements.length, action.payload + state.index),
            };
        case LightboxActionType.SetElements:
            return { ...state, elements: action.payload, index: clampListIndex(action.payload.length, state.index) };
        default:
            return { ...state, index: clampListIndex(state.elements.length - 1, state.index) };
    }
}

export default lightboxReducer;
